import React from 'react';
import {
  ScenarioSelectionRedefinedPreviewScenariosContainer,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ScenarioSelectionRedefinedPreviewScenarios/ScenarioSelectionRedefinedPreviewScenariosContainer';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';


const ScenarioSelectionRedefinedDecisionContent = () => {
  const { resource } = useMetaLayoutContext();
  const { setPageContentCollection } = usePageContentContext();

  // Since we are in the scenario selection wizard we should submit the current wizard step after we successfully select
  // so that we can navigate forward to the next relevant step
  const onSelectSuccess = async (_) => {
    const updatedColl = await resource.submit();
    await setPageContentCollection(updatedColl);
  };

  return (
    <ScenarioSelectionRedefinedPreviewScenariosContainer onSelectSuccess={onSelectSuccess} />
  );
};

ScenarioSelectionRedefinedDecisionContent.defaultProps = {
};

ScenarioSelectionRedefinedDecisionContent.propTypes = {
};

export default ScenarioSelectionRedefinedDecisionContent;
